import { ArrowLeft } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import TicketAttachments from "./ticketDetail/TicketAttachments";
import TicketConversation from "./ticketDetail/TicketConversation";
import TicketEmailHistory from "./ticketDetail/TicketEmailHistory";
import TicketManagement from "./ticketDetail/TicketManagement";
import TicketStatusHistory from "./ticketDetail/TicketStatusHistory";
import TicketSummary from "./ticketDetail/TicketSummary";

export default function TicketDetailView({ portal }) {
  const {
    developers: { activeDevelopers },
    navigation: { setActiveView },
    session: { user },
    tickets: {
      adminComment,
      adminStatus,
      developmentTimeMinutes,
      downloadAttachment,
      handleSendMessage,
      handleMessageFilesChange,
      handleStatusUpdate,
      handleTicketAssignmentChange,
      messageDraft,
      messageFiles,
      selectedTicket,
      setAdminComment,
      setAdminStatus,
      setDevelopmentTimeMinutes,
      setIsDeleteTicketDialogOpen,
      setMessageDraft,
    },
    ui: { loading },
  } = portal;

  return (
    <Card className="support-content-card">
      <CardHeader>
        <div className="support-detail-header">
          <button type="button" className="btn-secondary support-back-btn" onClick={() => setActiveView("tickets")}>
            <ArrowLeft className="w-4 h-4" />
            Retour aux tickets
          </button>
          <CardTitle className="heading-2">
            {selectedTicket ? selectedTicket.ticket_number : "Detail du ticket"}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent className="support-ticket-detail">
        {!selectedTicket && <p className="body-small">Aucun ticket selectionne.</p>}
        {selectedTicket && (
          <>
            <TicketSummary ticket={selectedTicket} userRole={user.role} />
            <TicketConversation
              loading={loading}
              messageDraft={messageDraft}
              messageFiles={messageFiles}
              messages={selectedTicket.messages}
              onDownload={downloadAttachment}
              onFilesChange={handleMessageFilesChange}
              onMessageChange={setMessageDraft}
              onSubmit={handleSendMessage}
              userRole={user.role}
            />
            <TicketAttachments
              attachments={selectedTicket.attachments}
              onDownload={downloadAttachment}
            />
            <TicketStatusHistory
              entries={selectedTicket.status_history}
              userRole={user.role}
            />
            {user.role === "admin" && (
              <TicketEmailHistory entries={selectedTicket.email_history} />
            )}
            <TicketManagement
              activeDevelopers={activeDevelopers}
              adminComment={adminComment}
              adminStatus={adminStatus}
              developmentTimeMinutes={developmentTimeMinutes}
              loading={loading}
              messageFiles={messageFiles}
              onAssignmentChange={handleTicketAssignmentChange}
              onCommentChange={setAdminComment}
              onDelete={() => setIsDeleteTicketDialogOpen(true)}
              onDevelopmentTimeChange={setDevelopmentTimeMinutes}
              onFilesChange={handleMessageFilesChange}
              onStatusChange={setAdminStatus}
              onSubmit={handleStatusUpdate}
              ticket={selectedTicket}
              userRole={user.role}
            />
          </>
        )}
      </CardContent>
    </Card>
  );
}
